"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determinePageCount = exports.Pager = void 0;
var _Pager = require("./Pager");
//imports with obligatory rename

//exports with proper, expected interface names
var Pager = _Pager.Pager;
exports.Pager = Pager;
var determinePageCount = _Pager.determinePageCount;
exports.determinePageCount = determinePageCount;